import axios from "axios";

export const loadAllCenterAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?status=${payload.appliedFilters.status}&limit=${
        payload.pageSize
      }&page=${payload.currentPage}&orderBy=${
        payload.sort ? payload.sort.dir : "desc"
      }&orderColumn=${payload.sort ? payload.sort.column : "id"}&search=${
        payload.search ?? ""
      }`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleCenterAPI = (payload) => {
  return axios
    .get(`/companies/${payload.companyId}/centres/${payload.centerId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
